module.exports = __webpack_public_path__ + "media/images/promo/forum-7fa5cba2acf4a32e1f106950a03a3467e6cd1279da04ef94db5a95d5b422f35f.png";